var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visibleProxy,
        title: "Lịch sử thêm số lượng",
        width: "720px",
        "close-on-click-modal": false,
        "append-to-body": "",
        "custom-class": "ps-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleProxy = $event
        },
      },
    },
    [
      _vm.schoolRow
        ? _c("div", { staticClass: "ps-history-header" }, [
            _c("div", [
              _c("span", { staticClass: "ps-history-header__eyebrow" }, [
                _vm._v("Lịch sử thêm số lượng"),
              ]),
              _c("h3", [_vm._v(_vm._s(_vm.schoolRow.school.name))]),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.schoolRow.package
                      ? _vm.schoolRow.package.code
                      : "Chưa gán gói"
                  ) +
                    " · " +
                    _vm._s(_vm.histories.length) +
                    " lần thêm"
                ),
              ]),
            ]),
            _c("div", { staticClass: "ps-history-total" }, [
              _c("span", [_vm._v("Tổng số lượng đã thêm")]),
              _c("strong", [
                _vm._v(
                  "+" + _vm._s(_vm._f("formatNumber")(_vm.schoolRow.addonTotal))
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "sk-table ps-table ps-history-table",
          attrs: {
            data: _vm.histories,
            border: "",
            size: "small",
            "empty-text": "Chưa có lịch sử thêm số lượng",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "Thời điểm", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDateTime")(row.createdAt))),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Số lượng thêm", width: "130", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", { staticClass: "ps-addon-amount" }, [
                      _vm._v("+" + _vm._s(_vm._f("formatNumber")(row.amount))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Lý do thêm số lượng",
              prop: "note",
              "min-width": "220",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "Người thực hiện",
              prop: "createdBy",
              width: "170",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "ps-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.visibleProxy = false
                },
              },
            },
            [_vm._v("Đóng")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }